<template>
    <div class="row">
        <div class="col-12">
            <label class="form-label">Dosya</label>
            <v-file-uploader v-model="value" value-parameter="File"></v-file-uploader>
            <div class="mt-50">
                <small>Eğer personelin girişi için SGK giriş belgesi yüklediyseniz. İptal ederken SGK iptal belgesi yüklemeniz gerekmektedir.</small>
            </div>
        </div>
    </div>
</template>

<script>
import VFileUploader from '@/components/v-file-uploader/VFileUploader.vue'
export default {
    components:{
        VFileUploader
    },
    props:{
        value:Object
    }
}
</script>